<div class="flex">
  <app-project-side-menu></app-project-side-menu>
  <p-divider class="mr-0!" layout="vertical"></p-divider>
  <app-project-content class="flex-1 min-w-0"></app-project-content>
</div>

<app-chapter-description-dialog></app-chapter-description-dialog>
